export default "__VITE_ASSET__DcyQDOvG__"